import APP_ACTIONS from '../constants/app-actions';

const initialState = {
    navigation: {
        katapulk: [],
    },
};

const navigation = (state = initialState, action) => {
    if (action.type === APP_ACTIONS.ADD_KATAPULK_NAVIGATION) {
        return { ...state, ...action.payload.navigation };
    }
    return state;
};

export default navigation;



/** WEBPACK FOOTER **
 ** ./src/reducers/navigation.js
 **/